import React from 'react';
import Header from '../components/Header';
import Navigation from '../components/Navigation';
import Footer from '../components/Footer';

const Schedule: React.FC = () => {
  return (
    <div id="schedule">
      <div className="banner-wrapper">
        <Header currentPage="schedule" />
        <Navigation />
      </div>
      <div className="page-content">
        <div className='page-heading' style={{fontFamily: 'Baskerville', letterSpacing: 0, fontStyle:'normal'}}>
          Friday, June 26, 2026
        </div>
        
        <div className='page-heading' style={{marginTop: '20px', marginBottom: '20px',fontFamily: 'Crimson', fontStyle: 'italic'}}>
          WELCOME DRINKS
        </div>
        <div className='page-body'>8:00 - 10:00 pm</div>
        <div className='page-body' style={{marginBottom: '24px'}}>Babblers Killside @ Wylder Windham</div>
        <div className='page-small-text'>Heading up to Windham on Friday? Swing by the hotel bar to say hello before the big day. Your first drink (or two) is on us! Our tab opens at 8, and the bride and groom plan to arrive around 9.</div>

        <div className='page-heading' style={{fontFamily: 'Baskerville', letterSpacing: 0, fontStyle:'normal'}}>
          Saturday, June 27, 2026
        </div>
        
        <div className='page-heading' style={{marginTop: '20px', marginBottom: '20px',fontFamily: 'Crimson', fontStyle: 'italic'}}>
          CEREMONY
        </div>
        <div className='page-body'>4:30 pm</div>
        <div className='page-body' style={{marginBottom: '24px'}}>Wylder Windham</div>
        <div className='page-small-text'>A brief ceremony will take place outdoors on the lawn. 
          Please keep this in mind when selecting your footwear.</div>
        
        <div className='page-heading' style={{marginTop: '60px', marginBottom: '20px',fontFamily: 'Crimson', fontStyle: 'italic'}}>
          COCKTAIL HOUR
        </div>
        <div className='page-body' style={{marginBottom: '24px'}}>Babblers Killside @ Wylder Windham</div>
        <div className='page-small-text'>Immediately following the ceremony, head up the hill for light bites and cocktails.</div>
        
        <div className='page-heading' style={{marginTop: '60px', marginBottom: '20px',fontFamily: 'Crimson', fontStyle: 'italic'}}>
          RECEPTION
        </div>
        <div className='page-body' style={{marginBottom: '24px'}}>Main Lodge @ Wylder Windham</div>
        <div className='page-small-text'>Celebrate the newlyweds and enjoy an evening of dining and dancing.</div>

        <div className='page-heading' style={{marginTop: '60px', marginBottom: '20px',fontFamily: 'Crimson', fontStyle: 'italic'}}>
          AFTER-PARTY
        </div>
        <div className='page-body' style={{marginBottom: '24px'}}>Rec Room @ Wylder Windham</div>
        <div className='page-small-text'>We're kicking on! Join us downstairs to keep the party going or enjoy a late-night s'more by the campfire.</div>
        
        <div className='page-heading' style={{fontFamily: 'Baskerville', letterSpacing: 0, fontStyle:'normal'}}>
          Sunday, June 28, 2026
        </div>
        
        <div className='page-heading' style={{marginTop: '20px', marginBottom: '20px',fontFamily: 'Crimson', fontStyle: 'italic'}}>
          FAREWELL BRUNCH
        </div>
        <div className='page-body'>9:00 am</div>
        <div className='page-body' style={{marginBottom: '24px'}}>Main Lodge @ Wylder Windham</div>
        <div className='page-small-text'>Before you head back home, join us for coffee and a bite to eat!</div>

      </div>
      <Footer />
    </div>
  );
};

export default Schedule;


